import { render, staticRenderFns } from "./AdvertisementTableViewRow.vue?vue&type=template&id=1f48c570&scoped=true"
import script from "./AdvertisementTableViewRow.vue?vue&type=script&lang=js"
export * from "./AdvertisementTableViewRow.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementTableViewRow.vue?vue&type=style&index=0&id=1f48c570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48c570",
  null
  
)

export default component.exports